import { render, staticRenderFns } from "./MemberCenterAdminEmailArchiveModal.vue?vue&type=template&id=3e752070&scoped=true&lang=pug&"
import script from "./MemberCenterAdminEmailArchiveModal.vue?vue&type=script&lang=js&"
export * from "./MemberCenterAdminEmailArchiveModal.vue?vue&type=script&lang=js&"
import style0 from "./MemberCenterAdminEmailArchiveModal.vue?vue&type=style&index=0&id=3e752070&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e752070",
  null
  
)

export default component.exports